export enum InboxMessageType {
	Custom = 0,
	MissionCompleted = 1,
	MissionUnlocked = 2,
	LeaderboardWon = 3,
	LevelChanged = 4,
	BonusGiven = 5,
	PointsAdded = 6,
	PointsUsed = 7,
	PersonalMessage = 8,
}

// keep in sync with BO enum
